var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { HBox, VBox } from "../structural_components/hbox_vbox";
import { Label, DescriptionLabel, ErrorLabel } from "./label";
import { createControlId } from "./id_creator";
import { bind } from "./control";
import { createEntityFieldGetter } from "../state/entity";
import { getFieldErrorsAsString } from "../validation/validatableentity";
import { cls_checkbox, cls_checkbox_indicator } from "./checkbox.css";
import { cls_form_item_box } from "./form_item.css";
import { CheckIcon } from '@radix-ui/react-icons';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cls_label_checkbox } from "./label.css";
import { cls_align_items_center, cls_box, cls_box_horizontal, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
var CheckboxIndicator = function (props) {
    return React.createElement(CheckboxPrimitive.Indicator, __assign({}, props, { className: "".concat(cls_checkbox_indicator, " ").concat(cls_box, " ").concat(cls_box_horizontal, " ").concat(cls_align_items_center, " ").concat(cls_justify_content_center) }));
};
var CheckboxRadix = function (props) {
    return React.createElement(CheckboxPrimitive.Root, __assign({}, props, { className: "".concat(cls_checkbox, " ").concat(cls_align_items_center, " ").concat(cls_justify_content_center) }));
};
var CheckboxBase = function (props) {
    var label = props.label, description = props.description, error = props.error, getter = props.getter, setter = props.setter, props_loc = __rest(props, ["label", "description", "error", "getter", "setter"]);
    var id = createControlId();
    var binding = bind(props);
    var value = binding.value;
    return React.createElement(VBox, { className: cls_form_item_box },
        React.createElement(HBox, { className: cls_align_items_center },
            React.createElement(CheckboxRadix, __assign({}, props_loc, { checked: value, onCheckedChange: function (e) { return binding.onChange(e.valueOf()); } }),
                React.createElement(CheckboxIndicator, null,
                    React.createElement(CheckIcon, null))),
            React.createElement(Label, { className: cls_label_checkbox }, label)),
        description ? React.createElement(DescriptionLabel, { htmlFor: id }, description) : React.createElement(React.Fragment, null),
        error ? React.createElement(ErrorLabel, null, error) : React.createElement(React.Fragment, null));
};
export var Checkbox = function (props) {
    var _a, _b, _c, _d;
    var getter = (_a = props.getter) !== null && _a !== void 0 ? _a : createEntityFieldGetter(props.state);
    var setter = props.setter || ((_b = props.actions) === null || _b === void 0 ? void 0 : _b.setEntityField) || null;
    var error = (_d = (_c = props.error) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : (props.state && props.name ? getFieldErrorsAsString(props.state, props.name) : null);
    return React.createElement(CheckboxBase, { label: props.label, name: props.name, description: props.description, getter: getter, setter: setter, error: error });
};
